<template>
  <v-dialog :key="itemKey" :value="value" width="800" @input.self="$emit('input', $event)">
    <v-card class="card-select-flyers">
      <v-card-title>
        <v-row>
          <v-flex xs11>
            <span class="title">{{ dialogTitle }}</span>
          </v-flex>
          <v-flex xs1 class="close-dialog">
            <mf-icon @click="closeDialog"> close </mf-icon>
          </v-flex>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-for="item in sortedItemsToShow" :key="item._id">
                <td>{{ item.name }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import orderBy from 'lodash/orderBy'

export default {
  props: {
    value: {
      type: [Object, Boolean],
      default: false,
    },
    dialogTitle: String,
    itemKey: String,
    itemsToShow: {
      type: [Array, Object],
      default: () => {
        return []
      },
    },
  },
  computed: {
    sortedItemsToShow() {
      return orderBy(this.itemsToShow, 'name')
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="scss">
.card-select-flyers {
  padding: 0 20px;

  .title {
    margin-left: 24px;
  }

  .exibition-mode {
    text-align: right;
    font-size: 20px;
  }

  .close-dialog {
    text-align: right;
  }
}
</style>
